<template>
    <div>
    <nav class="navbar navbar-expand-md navbar-custom">

        <div class="navbar-custom__left flex-md-grow-1 d-md-flex">

            <!-- Inicio Trigger Menú Off Canvas (Materialize) -->
            <a href="#" data-target="slide-out" class="sidenav-trigger text-decoration-none header__menu">
                <!-- Inicio SVG -->
                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="20.5" viewBox="0 0 31 20.5">
                    <g id="Grupo_53" data-name="Grupo 53" transform="translate(-37 -42.75)">
                        <line id="Línea_1" data-name="Línea 1" x2="28.5" transform="translate(38.25 44)" fill="none" stroke="#008ad8" stroke-linecap="round" stroke-width="2.5"/>
                        <line id="Línea_3" data-name="Línea 3" x2="13" transform="translate(38.25 62)" fill="none" stroke="#008ad8" stroke-linecap="round" stroke-width="2.5"/>
                        <line id="Línea_29" data-name="Línea 29" x2="21" transform="translate(38.25 53)" fill="none" stroke="#008ad8" stroke-linecap="round" stroke-width="2.5"/>
                    </g>
                </svg>
                <!-- Fin SVG -->
            </a>
            <!-- Fin Trigger Menú Off Canvas (Materialize) -->

            <!-- Inicio Trigger Menú desplegable usuario (Bootstrap) -->
            <button id="button-toggle-nav" class="navbar-toggler rounded-circle display-md-none icon-profile-user" type="button" data-toggle="collapse" data-target="#navbarCustom">
                <i class="fa fa-bars"></i>
            </button>
            <!-- Fin Trigger Menú desplegable usuario (Bootstrap) -->
            
            <!-- Inicio Logo -->
            <router-link to="/" class="header__item header__item">
                <img src="/assets/img/logo.png" alt="Digital solutions" class="imgLogoNav"/>
            </router-link>
            <!-- Fin Logo -->

            <!-- Inicio Buscador -->
            <div class="w-100 divSearchNav header__item">
                <div class="input-field">
                    <i class="material-icons prefix iconSeN">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSeN" placeholder="Searches">
                </div>
            </div>
            <!-- Fin Buscador -->

        </div>
            
        <div class="d-flex align-items-center ml-md-auto navbar-custom__right ">

            <!-- Inicio usuario móvil/escritorio -->
            <div class="justify-content-md-end navbarCustom">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" style="font-size: 15px; cursor: default;"><b>{{user.facility_name}}</b></a>
                    </li>
                    <li class="nav-item p-0 header__item">
                        <button class="nav-link" :href="'JavaScript:void(0);'" @click="getManual()">Help</button>
                    </li>
                    <li class="nav-item mr-3 header__item" style="position: relative;">
                        <a class="nav-link notification-header-item" href="JavaScript:void(0);">
                            Notifications
                            <!-- Inicio SVG -->
                            <svg class=" position-absolute ml-1" xmlns="http://www.w3.org/2000/svg" width="18.978" height="21.422" viewBox="0 0 18.978 21.422" style="margin-top: -5px">
                                <g id="Grupo_5526" data-name="Grupo 5526" transform="translate(-1673.708 -32.11)">
                                    <g id="Grupo_5525" data-name="Grupo 5525" transform="translate(1674.212 32)">
                                    <g id="Grupo_31" data-name="Grupo 31" transform="translate(0.921 0.497)">
                                        <g id="Grupo_26" data-name="Grupo 26" transform="translate(0 3.053)">
                                        <g id="Grupo_25" data-name="Grupo 25">
                                            <path id="Trazado_25" data-name="Trazado 25" d="M60.042,119.522l-1.5-2.5a7.421,7.421,0,0,1-1.056-3.815v-2.187a6.106,6.106,0,1,0-12.212,0v2.187a7.421,7.421,0,0,1-1.056,3.815l-1.5,2.5a.436.436,0,0,0,.374.66H59.668a.436.436,0,0,0,.374-.66Zm-16.178-.212,1.1-1.836a8.285,8.285,0,0,0,1.181-4.264v-2.187a5.234,5.234,0,1,1,10.468,0v2.187a8.293,8.293,0,0,0,1.18,4.264l1.1,1.836Z" transform="translate(-42.658 -104.917)" fill="#090909" stroke="#000" stroke-width="0.2"/>
                                        </g>
                                        </g>
                                        <g id="Grupo_28" data-name="Grupo 28" transform="translate(6.979 0)">
                                        <g id="Grupo_27" data-name="Grupo 27" transform="translate(0)">
                                            <path id="Trazado_26" data-name="Trazado 26" d="M203.273,35.414a1.746,1.746,0,0,0-1.745,1.745V38.9a.436.436,0,0,0,.872,0V37.159a.872.872,0,0,1,1.745,0V38.9a.436.436,0,0,0,.872,0V37.159A1.746,1.746,0,0,0,203.273,35.414Z" transform="translate(-201.528 -35.414)" fill="#090909" stroke="#000" stroke-width="0.2"/>
                                        </g>
                                        </g>
                                        <g id="Grupo_30" data-name="Grupo 30" transform="translate(6.543 17.447)">
                                        <g id="Grupo_29" data-name="Grupo 29" transform="translate(0 0)">
                                            <path id="Trazado_27" data-name="Trazado 27" d="M195.666,432.8a.437.437,0,0,0-.754.441,1.308,1.308,0,1,1-2.266,0,.437.437,0,0,0-.754-.441,2.182,2.182,0,1,0,3.774,0Z" transform="translate(-191.598 -432.581)" fill="#090909" stroke="#000" stroke-width="0.2"/>
                                        </g>
                                        </g>
                                    </g>
                                    <path id="Trazado_28" data-name="Trazado 28" d="M3808.624,717.009a5.919,5.919,0,0,1,4.407-5.946" transform="translate(-3806.59 -708.47)" fill="none" stroke="#000" stroke-width="1"/>
                                    <path id="Trazado_3050" data-name="Trazado 3050" d="M3808.624,717.009a5.919,5.919,0,0,1,4.407-5.946" transform="translate(-3808.621 -710.47)" fill="none" stroke="#000" stroke-width="1"/>
                                    </g>
                                </g>
                            </svg>
                            <!-- Fin SVG -->
                        </a>
                        <div class="p-2 shadow-lg bg-white rounded header-notification make-scrollable">
                            <ul v-if="notifications && notifications.length">
                                <li v-for="(item, index) in notifications" :key="index">
                                    <h6>{{ item.title }} </h6>
                                    <p>{{ item.message }}</p>
                                    <a v-if="item.link_text" @click="action(item.link_action, item.id)">{{ item.link_text }}</a>
                                    <div class="text-right mt-2">{{ moment(item.created_at).format('MM/DD/YYYY hh:mm a') }}</div>
                                    <hr v-if="index != notifications.length - 1">    
                                </li>
                            </ul>
                            <div v-else>
                                <h6>
                                    You have no notifications right now
                                </h6>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item">
                        
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" v-html="`Hello ${user.name}`"/>
                    </li>
                </ul>
            </div>
            <!-- Fin usuario móvil/escritorio -->

            <!-- Inicio imagen del usuario -->
            <span class="user ml-md-0">
                <img id="icon-profile-user" style="cursor: pointer;"  src="/assets/img/userimage.png" alt="" class="rounded-circle user__image icon-profile-user"/>
                <span class="rounded-circle online d-flex align-items-center justify-content-center user__status">
                    3
                </span>

                <div class="p-2 shadow-lg bg-white rounded header-menu-profile" id="header-menu-profile">
                    <button class="container__close" id="close-menu-profile" data-toggle="collapse" data-target="#navbarCustom">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.438" height="22.438" viewBox="0 0 22.438 22.438">
                        <g id="close" transform="translate(0.707 0.707)">
                            <line id="Línea_789" data-name="Línea 789" x2="21.023" y2="21.023" fill="none" stroke="#707070" stroke-width="2"/>
                            <line id="Línea_790" data-name="Línea 790" x2="21.023" y2="21.023" transform="translate(21.023 0) rotate(90)" fill="none" stroke="#707070" stroke-width="2"/>
                        </g>
                    </svg>
                    </button>

                    <div class="flex-column usermenu__content">

                        <div class="media align-items-center mt-2">
                            <span class="user mr-md-0">
                                <img  src="/assets/img/userimage.png" alt="" class="rounded-circle user__image"/>
                            </span>
                            <div class="media-body">
                                <h2 class="usermenu__name">
                                    {{user.name}}
                                </h2>
                                <a style="font-size: 15px; cursor: default;">
                                    {{  user.facility_name }}
                                </a>
                            </div>
                        </div>

                        <!-- Inicio Opciones -->
                        <ul class="navbar-nav usermenu__options" style="flex-direction: column;">
                            <li class="nav-item">
                                <a class="nav-link" href="#">
                                     <!-- Inicio SVG -->
                                     <svg xmlns="http://www.w3.org/2000/svg" width="17.686" height="19.043" viewBox="0 0 17.686 19.043">
                                        <g id="Grupo_6213" data-name="Grupo 6213" transform="translate(-31.657 -424.717)">
                                            <g id="Grupo_5942" data-name="Grupo 5942" transform="translate(35.786 424.917)">
                                            <path id="Trazado_3042" data-name="Trazado 3042" d="M13.714,15.929A4.63,4.63,0,0,1,9,11.214,4.63,4.63,0,0,1,13.714,6.5a4.63,4.63,0,0,1,4.714,4.714A4.63,4.63,0,0,1,13.714,15.929Zm0-7.857a3.143,3.143,0,1,0,3.143,3.143A3.152,3.152,0,0,0,13.714,8.071Z" transform="translate(-9 -6.5)" stroke="#fff" stroke-width="0.4"/>
                                            </g>
                                            <g id="Grupo_5943" data-name="Grupo 5943" transform="translate(31.857 435.702)">
                                            <path id="Trazado_3043" data-name="Trazado 3043" d="M23,21.857a.742.742,0,0,1-.786-.786V17.929a2.417,2.417,0,0,0-2.357-2.357H10.429a2.417,2.417,0,0,0-2.357,2.357v3.143a.742.742,0,0,1-.786.786.742.742,0,0,1-.786-.786V17.929A3.89,3.89,0,0,1,10.429,14h9.429a3.89,3.89,0,0,1,3.929,3.929v3.143A.742.742,0,0,1,23,21.857Z" transform="translate(-6.5 -14)" stroke="#fff" stroke-width="0.4"/>
                                            </g>
                                        </g>
                                    </svg>
                                    <!-- Fin SVG -->
                                    My account
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/profile-change-password">
                                    <!-- Inicio SVG -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" fill="currentColor" class="bi bi-lock" viewBox="0 0 16 16">
                                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" transform="translate(-3, 0)" stroke-width="0.4"/> 
                                    </svg>

                                    <!-- Fin SVG -->
                                    Change password
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/">
                                    <!-- Inicio SVG -->
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17.967" height="13.55" viewBox="0 0 17.967 13.55">
                                        <g id="interface_3_" data-name="interface (3)" transform="translate(11.15 114.15)">
                                            <g id="Grupo_2" data-name="Grupo 2" transform="translate(-11 -114)">
                                            <path id="Trazado_11" data-name="Trazado 11" d="M16.194,64H1.472A1.474,1.474,0,0,0,0,65.472V75.778A1.474,1.474,0,0,0,1.472,77.25H16.194a1.474,1.474,0,0,0,1.472-1.472V65.472A1.474,1.474,0,0,0,16.194,64Zm-14.722.736H16.194a.7.7,0,0,1,.153.031c-1.275,1.167-5.5,5.033-6.98,6.365a.738.738,0,0,1-1.069,0c-1.479-1.332-5.705-5.2-6.98-6.365A.7.7,0,0,1,1.472,64.736ZM.736,75.778V65.472a.711.711,0,0,1,.041-.2c.976.893,3.924,3.591,5.837,5.329C4.708,72.235,1.758,75.032.775,75.97A.709.709,0,0,1,.736,75.778Zm15.458.736H1.472a.7.7,0,0,1-.166-.034C2.322,75.512,5.291,72.7,7.163,71.1l.643.582a1.47,1.47,0,0,0,2.054,0L10.5,71.1c1.873,1.6,4.841,4.414,5.857,5.383A.7.7,0,0,1,16.194,76.514Zm.736-.736a.711.711,0,0,1-.039.192c-.984-.938-3.933-3.734-5.839-5.371,1.912-1.739,4.861-4.436,5.837-5.33a.711.711,0,0,1,.041.2Z" transform="translate(0 -64)" stroke="#000" stroke-width="0.3"/>
                                            </g>
                                        </g>
                                    </svg>
                                    <!-- Fin SVG -->
                                    Messages
                                </a>
                            </li>                       
                        </ul>
                        <!-- Fin Opciones -->

                        <!-- Inicio botón "Cerrar Sesión" -->
                        <button class="mx-auto usermenu__button button--1" @click="logout()">
                            Logout
                        </button>
                        <!-- Fin botón "Cerrar Sesión" -->

                    </div>
                </div>
            </span>
            <!-- Fin imagen del usuario -->

        </div>     
    </nav>
    <UploadSummary
            :breadcrumb="room_breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="name_file_summary"
            name="generalUploadSummary"
            :id="'general_upload_summary'"
        />
    </div>
</template>

<script>

import moment from 'moment'
import Resources                    from    '@/components/BuildingComponent/Rooms/resources'
import AssignmentResources          from    '@/components/AssigmentsComponent/DailyAssignment/resources'
import TaskResources                from    '@/components/AssigmentsComponent/Task/resources'
import FloorResources               from    '@/components/OptionsComponent/FloorTypes/resources'
import DefaultProjectCodeResources  from    '@/components/OptionsComponent/DefaultProjectCode/resources'
import ScheduleResources            from    '@/components/DayOffComponent/Schedule/resources'
import TemplateResources            from    '@/components/DayOffComponent/Template/resources'
import RoomTypeResources            from    '@/components/BuildingComponent/RoomTypes/resources'
import MasterStepCodeResources      from    '@/components/OptionsComponent/MasterStepCodes/resources'
import InspectionTemplateResources  from    '@/components/QcComponent/InspectionTemplate/resources'
import VacantBedResources  from    '@/components/CensusComponent/VacantBed/resources'
import UploadSummary                from    '@/components/UploadSummary'
import { getSocket } from '../../plugins/socket'
import eventBus from '../../plugins/eventBus'

export default {
    name:   'Header',
    components:
    {
        UploadSummary
    },
    props:[

    ],
    data(){
        return{
            user: this.get_user(),
            notifications: [],
            excel_file_headers: Resources.excel_file_headers,
            rest_api: 'notifications',
            rest_api_global: 'global_methods',
            storage_report_path: '',

            name_file_summary: 'rooms_failed_template_file',
            summary: [],
            excel_data: [],
            room_breadcrumb: [
                {
                    name:   'Home',
                    href:   '/',
                    arrow:  "<span class='slash'>/</span>",
                },
                {
                    name:   'Notifications',
                    href:   '#',
                    arrow:  "",
                },
            ],

            moment
        }
    },

    methods:
    {
        async getNotifications()
        {
            const response = await this.get(`${this.rest_api}`)

            if(response.status)
            {
                this.notifications = response.data.notifications
                this.storage_report_path = response.data.storage_report_path
            }
            else
            {
                this.error_handling(response)
            }

        },

        async action(link_action, id)
        {
            if(link_action == 'rooms_upload')
            {
                this.excel_file_headers = Resources.excel_file_headers
                this.name_file_summary = 'rooms_failed_template_file'
            }

            else if(link_action == 'room_tasks_upload')
            {
                this.excel_file_headers = Resources.excel_file_headers_tasks
                this.name_file_summary = 'tasks_failed_template_file'
            }

            else if(link_action == 'assignment_rooms_upload')
            {
                this.excel_file_headers = AssignmentResources.excel_file_headers_rooms
                this.name_file_summary = 'assignment_rooms_failed_template_file'
            }

            else if(link_action == 'duty_notes_upload')
            {
                this.excel_file_headers = AssignmentResources.excel_file_headers_notes
                this.name_file_summary = 'duty_notes_failed_template_file'
            }
            else if(link_action == 'task_steps_upload')
            {
                this.excel_file_headers = TaskResources.excel_file_headers_steps
                this.name_file_summary = 'task_steps_failed_template_file'
            }
            else if(link_action == 'floor_tasks_upload')
            {
                this.excel_file_headers = FloorResources.excel_file_headers_tasks
                this.name_file_summary = 'floor_tasks_failed_template_file'
            }
            else if(link_action == 'default_project_codes_upload')
            {
                this.excel_file_headers = DefaultProjectCodeResources.excel_file_headers
                this.name_file_summary = 'default_project_codes_failed_template_file'
            }

            else if(link_action == 'schedules_upload')
            {
                this.excel_file_headers = ScheduleResources.excel_file_headers
                this.name_file_summary = 'live_schedules_failed_template_file'
            }

            else if(link_action == 'templates_upload')
            {
                this.excel_file_headers = TemplateResources.excel_file_headers
                this.name_file_summary = 'master_days_off_failed_template_file'
            }
            else if(link_action == 'room_type_tasks_upload')
            {
                this.excel_file_headers = RoomTypeResources.excel_file_task_headers
                this.name_file_summary = 'room_type_tasks_failed_template_file'
            }
            else if(link_action == 'master_step_codes_upload')
            {
                this.excel_file_headers = MasterStepCodeResources.excel_file_headers
                this.name_file_summary = 'inspection_items_failed_template_file'
            }

            else if(link_action == 'inspection_templates_upload')
            {
                this.excel_file_headers = InspectionTemplateResources.excel_file_headers
                this.name_file_summary = 'inspection_templates_failed_template_file'
            }

            else if(link_action == 'room_types_inspection_template_upload')
            {
                this.excel_file_headers = InspectionTemplateResources.excel_file_headers_room_types
                this.name_file_summary = 'room_types_inspection_template_failed_template_file'
            }
            else if(link_action == 'inspection_items_inspection_template_upload')
            {
                this.excel_file_headers = InspectionTemplateResources.excel_file_headers_inspection_items
                this.name_file_summary = 'inspection_items_inspection_template_failed_template_file'
            }
            else if(link_action == 'bed_status_upload')
            {
                this.excel_file_headers = VacantBedResources.excel_file_headers
                this.name_file_summary = 'vacant_bed_code_failed_template_file'
            }

            this.loader(true)

            const response = await this.get(`${this.rest_api}/${id}`)

            if(response.status)
            {
                const data = response.data.notification

                if(link_action == 'download_report')
                {
                    // this.download(data.text_1)
                    window.open(data.text_1.file_path, '_blank');
                }
                else
                {
                    this.summary     = data.text_1 
                    this.excel_data  = data.text_2
                    window.$('#general_upload_summary').modal('show')
                }
            }
            else
            {
                this.error_handling(response)
            }
            this.loader()
        },

        async download(response = {}) {
            console.log(response);
            this.downloadFile({data: response});
        },

        async getManual()
        {
            const response  = await this.get(`${this.rest_api_global}/get_manual`)

            if(response.status)
            {
                if(!response.data.full_url) return this.notyfMesg('No user manual is available', 'error')

                window.open(response.data.full_url, '_blank')

                // this.downloadFile(response);
            }
            else
            {
                this.error_handling(response)
            }
        }

    },

    mounted()
    {
        this.getNotifications();
    },

    created()
    {
        eventBus.$on('header_notifications', () => 
        {
            const socket = getSocket();

            socket.on(`upload-${this.get_user().id}`, (data) => {
                const header = document.querySelector('.header-notification')
                header.style.display = 'block'
                this.notifications.unshift(data.notification)
            })
        })
    }
}

</script>